/* eslint-disable */
import "./xtxasyn"
/**
 * 登录和绑定相关方法
 * 
*/

/* ------------------------------------------
    返回code：
    0: 成功 
    2: 未插入设备证书
    3：pin码错误
    4: 数据签名失败
    5: 生成数字证书失败
  --------------------------------------------
*/

/**
 * 获取已安装的证书用户列表
 * @param null
 * @returns {string} 返回的证书用户列表格式为：用户名1||CertID1&&&用户名2||CertID2&&&用
    户名3||CertID3&&&.
 * @des 获取已安装的证书用户列表 
*/

const getUserList = async () => {
  const data = {
    code: 0,
    data: null,
    msg: ""
  }

  await new Promise((resolve, reject) => {
    SOF_GetUserList(function (retObj) {
      const len = retObj.retVal.indexOf("||")
      if (len == -1) {
        data.code = 2
        data.msg = "未取到证书, 请确认设备证书是否插入!"
        resolve(data)
        return data;
      }

      const regex = /\|\|(.+?)&&&/;
      const match = retObj.retVal.match(regex);
      const certId = match ? match[1] : "";
  
      data.data = certId
      resolve(data)
  
    });
  })

  return data

}

/**
 * pin码登录
 * @param certId 证书用户列表
 * @param passwd pin码
 * @returns {{code: number, data: boolean, msg: string}} 返回是否pin码是否成功
 * @des 获取pin码是否成功
*/
const test_SOF_Login = async (certId, passwd) => {

  const data = {
    code: 0,
    data: null,
    msg: ""
  }
  await new Promise((resolve) => {
    var time_begin = new Date();
    SOF_LoginEx(certId, passwd, 0, function (retObj) {
      
      if (!retObj.retVal) {
        data.code = 3
        data.data = false
        data.msg = "pin码错误，请重试！"
        resolve(data)
        return data;
      }

      data.data = true
      resolve(data)
    
  }, {begin:time_begin, certId:certId});
  })
 
  return data
}


/**
 * 获取所有的设备序列号
 * @param null
 * @returns {string} FOU"11111;22222;"
 * 
*/
const test_GetAllDeviceSN = async() => {

  const data = {
    code: 0,
    data: null,
    msg: ""
  }

  await new Promise((resolve, reject) => {
    GetAllDeviceSN(function (retObj) {
      const len = retObj.retVal.indexOf(";")
      if (len == -1) {
        data.code = 2
        data.msg = "未取到证书, 请确认设备证书是否插入!"
        resolve(data)
        return data;
      }
      const certArr = retObj.retVal?.split(";")
      const certSN = certArr[0]
  
      data.data = certSN
      resolve(data)
  
    });
  })

  

  return data
}

/**
 * 获取已安装的证书用户列表
 * @param null
 * @returns {{code: number, data: string | null, msg: string}} 证书用户列表 
 * @des 返回的证书用户列表格式为：用户名1||CertID1&&&用户名2||CertID2&&&用户名3||CertID3&&&... 
 * CertID是证书操作唯一标识，格式为 容器名称/设备序列号。通过CertID可以找到唯一的签名证书、加密证书，并使用对应密钥
*/
const test_SOF_GetUserList = async () => {

  const data = {
    code: 0,
    data: null,
    msg: ""
  }

  await new Promise((resolve, reject) => {

    SOF_GetUserList(function(retObj){
      
      const len = retObj.retVal.indexOf("&&&")
      if (len == -1) {
        data.code = 2
        data.msg = "未取到证书, 请确认设备证书是否插入!"
        resolve(data);
        return;
      }
    
      // const certArr = retObj.retVal?.split(";")
      // const certSN = certArr[0]
    
      // 处理||前面的内容 获取证书单位名称
      const startIndex = retObj.retVal.indexOf("&&&") + 3;
      const endIndex = retObj.retVal.indexOf("||");
      const userNameGN = retObj.retVal.substring(0, endIndex);
    
      // 处理/后面的内容 获取SN
      const startSNIndex = retObj.retVal.indexOf("/") + 1;
      const endSNIndex = retObj.retVal.indexOf("&&&");
      const certSN = retObj.retVal.substring(startSNIndex, endSNIndex);

      // 获取certId 单位cs1||998000101075364/5903202208029055&&&
      const regex = /\|\|(.+?)&&&/;
      const match = retObj.retVal.match(regex);
      const certId = match ? match[1] : "";
    
      data.data = {
        // SN
        bindData: certSN,
        // 主体机构名称
        userNameGN,
        // 证书ID
        certId
      }
      resolve(data);
      });

  })

  return data
}

/**
 * 对随机数进行签名
 * @param CertID 证书操作唯一标识，也支持只输入设备序列号
 * @returns {{code: number, data: {data: string, sign: string}, msg: string}} 成功返回 Base64 编码的签名值和原随机数，失败返回空 
 * @des 对数据进行数字签名
*/
const randomSignData = async (certId) => {
  const data = {
    code: 0,
    data: null,
    msg: ""
  }
  if (certId == "") {
    return;
  }

  var plain = Math.random().toString(36).substr(2, 6);
  
  await new Promise((resolve) => {
    SOF_SignData(certId, plain, function (retObj) {
      if (retObj.retVal == "") {
        data.code = 4
        data.msg = "数据签名失败!"
        resolve(data);
      }
      const { certId } = retObj.ctx
      data.data = {
        // 随机数
        data: plain,
        // 签名结果
        sign: retObj.retVal
      }
      resolve(data); 
    }, {certId: certId});
  });

  return data
}

/**
 * 导出用户加密证书
 * @param CertID 证书操作唯一标识，也支持只输入设备序列号
 * @returns {{code: number, data: string, msg: string}} 成功返回 Base64 编码的证书，失败返回空
 * @des 导出用户加密证书
*/
const getUserCert = async (certId) => {
  const data = {
    code: 0,
    data: null,
    msg: ""
  }
  if (certId == "") {
    return;
  }

  await new Promise((resolve) => {
    SOF_ExportExChangeUserCert(certId, function (retObj) {
      if (retObj.retVal == "") {
        data.code = 5
        data.msg = "生成数字证书失败!"
        resolve(data);
      }
      data.data = retObj.retVal
      resolve(data); 
    });
  });
  return data
}

export default {
  getUserList,
  test_SOF_Login,
  test_GetAllDeviceSN,
  test_SOF_GetUserList,
  randomSignData,
  getUserCert
}


